import { LocationDetailForm } from "@/features/location/detail/LocationDetailForm";
import { useModal } from "@/features/modal/ModalStackManager";
import { SiteDetailForm } from "@/features/site/components/form/SiteDetailForm";
import { DetailBadge } from "@/features/ui/detail/DetailBadge";
import { DetailContent } from "@/features/ui/detail/DetailContent";
import { DetailField } from "@/features/ui/detail/DetailField";
import { DetailHeader } from "@/features/ui/detail/DetailHeader";
import { DetailInformTitle } from "@/features/ui/detail/DetailInformTitle";
import { DetailLabel } from "@/features/ui/detail/DetailLabel";
import { DetailLink } from "@/features/ui/detail/DetailLink";
import { DetailLinkWrapper } from "@/features/ui/detail/DetailLinkWrapper";
import { DetailTitle } from "@/features/ui/detail/DetailTitle";
import { Checkbox, Space } from "@mantine/core";
import { AuthSignupPost201ResponseEquipment } from "@sizlcorp/sizl-api-document/dist/models";
import { useTranslation } from "react-i18next";

const DetailEquipment = Object.assign(DetailHeader, {
  Title: DetailTitle,
  Inform: DetailInformTitle,
  Field: DetailField,
  Label: DetailLabel,
  Link: DetailLink,
  LinkWrapper: DetailLinkWrapper,
  Badge: DetailBadge,
  Content: DetailContent,
  CheckBox: Checkbox,
});

export interface DetailEquipmentInformProps {
  data: AuthSignupPost201ResponseEquipment | any;
}

export const EquipmentDetailInForm = (params: DetailEquipmentInformProps) => {
  const { data } = params;
  const equipment = data?.data?.rows[0];
  const { openModal } = useModal();
  const { t } = useTranslation();

  return (
    <>
      <DetailEquipment>
        <DetailEquipment.Title>
          {t("common.detail", { item: `${t("equipment.equipment")}` })}
        </DetailEquipment.Title>
        <Space h={8} />
        <DetailEquipment.Field>
          <DetailEquipment.Label>{t("equipment.code")}</DetailEquipment.Label>
          <DetailEquipment.Content>{equipment?.code}</DetailEquipment.Content>
        </DetailEquipment.Field>
        <DetailEquipment.Field>
          <DetailEquipment.Label>{t("equipment.name")}</DetailEquipment.Label>
          <DetailEquipment.Content>{equipment?.name}</DetailEquipment.Content>
        </DetailEquipment.Field>
        <DetailEquipment.Field>
          <DetailEquipment.Label>{t("equipment.type")}</DetailEquipment.Label>
          <DetailEquipment.Content>{equipment?.equipmentType}</DetailEquipment.Content>
        </DetailEquipment.Field>
        <DetailEquipment.Field>
          <DetailEquipment.Label>{t("equipment.volt")}</DetailEquipment.Label>
          <DetailEquipment.Content>{equipment?.volt}</DetailEquipment.Content>
        </DetailEquipment.Field>
        <DetailEquipment.Field>
          <DetailEquipment.Label>{t("site.code")}</DetailEquipment.Label>
          <DetailEquipment.Link
            onClick={() => openModal(<SiteDetailForm siteCode={equipment?.siteCode} />, null, "")}
          >
            {equipment?.siteCode}
          </DetailEquipment.Link>
        </DetailEquipment.Field>
        <DetailEquipment.Field>
          <DetailEquipment.Label>{t("equipment.seq")}</DetailEquipment.Label>
          <DetailEquipment.Content>{equipment?.seq}</DetailEquipment.Content>
        </DetailEquipment.Field>
        <DetailEquipment.Field>
          <DetailEquipment.Label>{t("equipment.toLocationCode")}</DetailEquipment.Label>
          <DetailEquipment.Link
            onClick={() =>
              openModal(<LocationDetailForm locationCode={equipment?.toLocationCode} />, null, "")
            }
          >
            {equipment?.toLocationCode}
          </DetailEquipment.Link>
        </DetailEquipment.Field>
        <DetailEquipment.Field>
          <DetailEquipment.Label>{t("equipment.toLocationName")}</DetailEquipment.Label>
          <DetailEquipment.Content>{equipment?.toLocationName}</DetailEquipment.Content>
        </DetailEquipment.Field>
        <DetailEquipment.Field>
          <DetailEquipment.Label>{t("equipment.targetLocationCode")}</DetailEquipment.Label>
          <DetailEquipment.Link
            onClick={() =>
              openModal(
                <LocationDetailForm locationCode={equipment?.targetLocationCode} />,
                null,
                "",
              )
            }
          >
            {equipment?.targetLocationCode}
          </DetailEquipment.Link>
        </DetailEquipment.Field>
        <DetailEquipment.Field>
          <DetailEquipment.Label>{t("equipment.targetLocationName")}</DetailEquipment.Label>
          <DetailEquipment.Content>{equipment?.targetLocationName}</DetailEquipment.Content>
        </DetailEquipment.Field>
      </DetailEquipment>
    </>
  );
};
